import React, { useEffect, useState } from "react";
import InfiniteTable from "./InfiniteTable";
import { Container, Alert } from "@mui/material";
import { backend, API_URL } from "../backend_api";

const columns = [
  { id: "from_date", label: "From Date" },
  { id: "to_date", label: "To Date" },
  { id: "payout_date", label: "Payout Date" },
  { id: "status", label: "Status" },
  { id: "basis", label: "Basis" },
  { id: "adjustments", label: "Adjustments" },
  { id: "tax_passed_through", label: "Tax passed through" },
  { id: "tax_not_passed_through", label: "Tax not passed through" },
  { id: "fees_absorbed", label: "Fees absorbed" },
  { id: "fees_not_absorbed", label: "Fees not absorbed" },
  { id: "raas_fees", label: "Raas fees" },
  { id: "extra_fees", label: "Extra fees" },
  { id: "total_payout", label: "Total Payout" },
  { id: "partner", label: "Partner" },
  { id: "entity", label: "Entity" },
];

const usd = (n) =>
  n === null || n === undefined
    ? "n/a"
    : "$" + Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const PayoutCalculate = (props) => {
  const {
    selectedDateFrom,
    selectedDateTo,
    selectedDatePayout,
    selectedPartner,
    selectedEntity,
    selectedBrand,
    payin,
  } = props;

  const query =
    "from_date=" +
    selectedDateFrom +
    "&to_date=" +
    selectedDateTo +
    "&payout_date=" +
    selectedDatePayout +
    "&no_page=1" +
    (selectedPartner !== "" ? "&partner=" + selectedPartner : "") +
    (selectedEntity !== "" ? "&entity=" + selectedEntity : "") +
    (selectedBrand !== "" ? "&brand=" + selectedBrand : "") +
    (payin ? "&pay_in=" + payin : "");

  const [preflight, setPreflight] = useState(null);
  const [preflightError, setPreflightError] = useState(null);

  useEffect(() => {
    let alive = true;
    setPreflight(null);
    setPreflightError(null);
    backend
      .get(`${API_URL}data/api/payoutpreflight/?${query}`)
      .then(({ data }) => {
        if (alive) setPreflight(data);
      })
      .catch((error) => {
        if (alive) setPreflightError(String(error));
      });
    return () => {
      alive = false;
    };
  }, [query]);

  const banner = () => {
    if (preflightError) return <Alert severity="warning">Preflight check failed: {preflightError}</Alert>;
    if (!preflight) return <Alert severity="info">Checking Stripe balance against this run…</Alert>;
    const { run_total, rows, partners, stripe_available, stripe_pending, stripe_livemode, stripe_error, short_by, existing_rows } = preflight;
    const summary = `Run total ${usd(run_total)} (${rows} rows / ${partners} partners)`;
    if (existing_rows > 0)
      return <Alert severity="error">{existing_rows} payout row(s) already exist for these dates. Finish will be BLOCKED. Use Retry Payout.</Alert>;
    if (stripe_error) return <Alert severity="warning">{summary}. Stripe balance unavailable: {stripe_error}</Alert>;
    if (stripe_livemode === false)
      return <Alert severity="warning">{summary}. Stripe key is TEST MODE (balance {usd(stripe_available)} is not real money). This is not production.</Alert>;
    if (short_by > 0)
      return <Alert severity="error">{summary}. Stripe available {usd(stripe_available)} is SHORT by {usd(short_by)} (pending {usd(stripe_pending)}). Top up before Finish, or use Save only and pay a cohort from Retry.</Alert>;
    return <Alert severity="success">{summary}. Stripe available {usd(stripe_available)} (pending {usd(stripe_pending)}). OK to Finish.</Alert>;
  };

  return (
    <>
      <Container style={{ textAlign: "left", marginBottom: 12 }}>{payin ? <></> : banner()}</Container>
      <Container>
        <InfiniteTable
          apiep={"data/api/calculatepayouts?" + query}
          columns={columns}
          data={null}
          dataMapByColumn="id"
          deletable={false}
          editable={null}
          filterable={true}
          label="Order Calculations"
          fetchingModal={{
            title: "Calculating",
            description:
              "This may take some time relative to the number of payouts.",
          }}
        />
      </Container>
    </>
  );
};
